import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { DimensionSelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/gl-account/glaccount-selector-result-dto';
import { VendorHeaderTemplateRawDto } from './vendor-header-template-raw-dto';
import { VendorLineItemCodingTemplateRawDto } from './vendor-line-item-coding-template-raw-dto';
import { WFEBankAccountResultDto } from './wfe-bank-account-result-dto';
import { WFESpecialHandlingResultDto } from './wfe-special-handling-result-dto';
const ɵ0 = () => WFESpecialHandlingResultDto, ɵ1 = () => WFEBankAccountResultDto, ɵ2 = () => GLAccountSelectorResultDto, ɵ3 = () => DimensionSelectorResultDto, ɵ4 = () => VendorLineItemCodingTemplateRawDto, ɵ5 = () => VendorHeaderTemplateRawDto;
export class VendorCodingDefaultEditorResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], VendorCodingDefaultEditorResultDto.prototype, "specialHandlings", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], VendorCodingDefaultEditorResultDto.prototype, "bankAccounts", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], VendorCodingDefaultEditorResultDto.prototype, "glAccounts", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], VendorCodingDefaultEditorResultDto.prototype, "dimensions", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Array)
], VendorCodingDefaultEditorResultDto.prototype, "lineItemTemplates", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", VendorHeaderTemplateRawDto)
], VendorCodingDefaultEditorResultDto.prototype, "headerTemplate", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
